export enum ManufacturerMainNavigationItem {
    News = 'news',
    Retailers = 'retailers',
    Content = 'content',
    Reorder = 'reorder',
    Preorder = 'preorder',
    DataManager = 'data-manager'
}
